// @ts-nocheck

import React, { useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';

import { WinaTVSvg } from '../../assets/svg';
import { Target, isIOSEmbeddedAndStandalone } from '../../client';
import config from '../../config/app.config';
import { getLang } from '../../i18n/l10n';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

const StyledTvIcon = styled(WinaTVSvg)`
  position: absolute;
  height: 100%;
  width: 50%;

  top: 10%;
  left: 50%;
  transform: translateX(-50%);

  pointer-events: none;
  z-index: 0;
`;

const Interactive = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

const IframeWrapper = styled.div`
  width: 100%;
  height: 50%;
  iframe {
    height: 100%;
  }
`;

const TouchEventHandler = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const ChatLoader = () => {
  const touchHandlerElRef = useRef(null);
  const startRef = useRef(null);
  const isScrollingRef = useRef(null);
  const deltaRef = useRef(null);

  let url = `${config.webHost[getLang()]}/betting/tv/get_iframe.php`;
  let chatUrl = `${config.webHost[getLang()]}/betting/tv/chat.php`;

  if (isIOSEmbeddedAndStandalone) {
    chatUrl += `?iframe=1&jwt=${window.getJWT()}`;
    url += '?iframe=1';
  }

  const onTouchMove = useCallback(
    (event) => {
      if (Target.__MOBILE__ && touchHandlerElRef) {
        // ensure swiping with one touch and not pinching
        if (event.touches.length > 1 || (event.scale && event.scale !== 1)) return;
        const touches = event.touches[0];
        // measure change in x and y
        deltaRef.current = {
          x: touches.pageX - this.start.x,
          y: touches.pageY - this.start.y,
        };
        // determine if scrolling test has run - one time test
        if (isScrollingRef.current === undefined) {
          isScrollingRef.current = !!(
            isScrollingRef.current || Math.abs(deltaRef.current.x) < Math.abs(deltaRef.current.y)
          );
        }
      }
    },
    [touchHandlerElRef],
  );

  const onTouchEnd = useCallback(() => {
    if (Target.__MOBILE__ && touchHandlerElRef) {
      touchHandlerElRef.removeEventListener('touchmove', onTouchMove, false);
      touchHandlerElRef.removeEventListener('touchend', onTouchEnd, false);

      global.requestAnimationFrame(() => {
        touchHandlerElRef.current.style.pointerEvents = 'all';
      });
    }
  }, [touchHandlerElRef, onTouchMove]);

  const onTouchStart = useCallback(
    (event) => {
      if (Target.__MOBILE__ && touchHandlerElRef) {
        const touches = event.touches[0];
        // measure start values
        startRef.current = {
          // get initial touch coords
          x: touches.pageX,
          y: touches.pageY,
          // store time to determine touch duration
          time: +new Date(),
        };
        // used for testing first move event
        isScrollingRef.current = undefined;
        // reset delta and end measurements
        deltaRef.current = {};
        touchHandlerElRef.current.style.pointerEvents = 'none';
        // attach touchmove and touchend listeners
        touchHandlerElRef.current.addEventListener('touchmove', onTouchMove, false);
        touchHandlerElRef.current.addEventListener('touchend', onTouchEnd, false);
      }
    },
    [touchHandlerElRef, onTouchMove, onTouchEnd],
  );

  useEffect(() => {
    const touchHandlerElRefCurrent = touchHandlerElRef?.current;
    if (Target.__MOBILE__) {
      touchHandlerElRefCurrent.addEventListener('touchstart', onTouchStart);
    }
    return () => {
      if (Target.__MOBILE__) {
        touchHandlerElRefCurrent.removeEventListener('touchstart', onTouchStart, true);
        touchHandlerElRefCurrent.removeEventListener('touchmove', onTouchMove, false);
        touchHandlerElRefCurrent.removeEventListener('touchend', onTouchEnd, false);
      }
    };
  }, [onTouchStart, onTouchMove, onTouchEnd]);

  return (
    <Wrapper>
      {Target.__MOBILE__ ? <TouchEventHandler ref={touchHandlerElRef} /> : null}
      <StyledTvIcon />
      <Interactive>
        <IframeWrapper>
          <iframe title="Winamax TV" src={url} frameBorder="0" width="100%" height="100%" scrolling="no" />
        </IframeWrapper>
        <IframeWrapper>
          <iframe title="Winamax TV chat" src={chatUrl} width="100%" height="100%" frameBorder="0" scrolling="no" />
        </IframeWrapper>
      </Interactive>
    </Wrapper>
  );
};

export default React.memo(ChatLoader);
